import React from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import RegistrationForm from '../../features/authentication/registrationForm/RegistrationForm';

function Register() {
  return (
    <RegistrationForm />
  );
}

export default Register;
